<template>
  <!--<div id="nav">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </div>-->
  <div id="app_mainDiv">
    <router-view/>

    <VModal v-model="isLoading" :click-to-close='false' :overlayStyle="overlayStyle">
      <div class="loading_circle">
        <div class="load_circle1 load_circle"></div>
        <div class="load_circle2 load_circle"></div>
        <div class="load_circle3 load_circle"></div>
        <div class="load_circle4 load_circle"></div>
        <div class="load_circle5 load_circle"></div>
        <div class="load_circle6 load_circle"></div>
        <div class="load_circle7 load_circle"></div>
        <div class="load_circle8 load_circle"></div>
        <div class="load_circle9 load_circle"></div>
        <div class="load_circle10 load_circle"></div>
        <div class="load_circle11 load_circle"></div>
        <div class="load_circle12 load_circle"></div>
      </div>
    </VModal> 
    <modals-container></modals-container>
  </div>
</template>

<script>
// import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { createNamespacedHelpers } from 'vuex'
import VModal from '@/components/common/VModal.vue'

const commonHelper = createNamespacedHelpers('common')
export default {
    created() {
      console.log(this.$store);
    },
    data: function(){
      return {
        // color: "#5dc596",
        // size: 40,
        overlayStyle: {
          'background-color': 'rgba(0,0,0,0)'
        },
        // contentStyle: {
        //   'background-color': 'rgba(0,0,0,0)',
        //   'border' : 'none'
        // }
      }
    },
    components: {
      // ScaleLoader, 
      VModal
    },
    methods: {
        showSpinner() {
            console.log('show spinner');
            this.spinnerVisible = true;
        },
        hideSpinner() {
            console.log('hide spinner');
            this.spinnerVisible = false;
        },
        ...commonHelper.mapMutations([
            'changeLoadingFlag'
        ]),
        ...commonHelper.mapActions([
            'callMutation'
        ])
    },
    computed: {
      ...commonHelper.mapState({
          loading: state => state.loading
      }),
      ...commonHelper.mapGetters([
        'isLoading'
      ])
    }
}
</script>

<style>
#app {
  height: 100%;
}

#app_mainDiv { 
  height: 100%;
}
</style>